/*
 * @Description: 用户管理stroe
 * @Author: wangzhenxin (834529118@qq.com)
 * @Date: 2019-05-24 09:14:44
 * @LastEditTime: 2020-09-28 17:26:33
 * @LastEditors:   YOYO [792611446@qq.com]
 */
import deviceMana from './deviceMana/store'
import equipmentGroup from './equipmentGroup/store'

export const deviceManagementStore = {
  deviceMana,
  equipmentGroup,
}

export default deviceManagementStore
